/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_LinkingInputs */



/**
* | output |
* | --- |
* | "Linking..." |
*
* @param {Vekn_LinkingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_linking = /** @type {((inputs?: Vekn_LinkingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_LinkingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liaison...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vinculando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vinculando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collegamento...")
	return /** @type {LocalizedString} */ ("Linking...")
});